import React from 'react'
import { matchPath, Route, Routes, useLocation } from 'react-router'
import { ABOUTUS, COMPANIES, CONTACT, COURSEDETAILS, COURSES, EVENTSDETAILS, HOME, PLACEMENTS, REFUND_POLICY, TANDC } from '../_utils/Routes'
import { SUPERX } from '../_utils/Routes'
import { LOGIN_PERMISSION } from '../_utils/Routes'
import C2wSuperxHome from './C2wSuperxHomePage/superxIndex'
import C2wLoginPermission from './c2wHomePage/setting/loginPermission/loginPermission'
// import C2wAboutus from './c2wHomePage/setting/aboutus/aboutus'
import C2wNavbar from '../components/C2wNavbar/navbarIndex'
import C2wTermsAndConditions from './c2wHomePage/setting/termsandCondition/TermsAndConditions'
import C2wRefundPolicy from './c2wHomePage/setting/refund/RefundPolicy'
import { useSelector } from 'react-redux'
import SettingsSheet from './c2wHomePage/setting/settingSheet/SettingsSheet'
import C2wEnquiry from './c2wHomePage/setting/enquiry/enquiry'
import C2wCourses from './c2wHomePage/courses/courses'
import C2wPlacemets from './c2wHomePage/placements/placemets'
import C2wCompanies from './c2wHomePage/companies/companies'
import C2wCoursesDetails from './c2wHomePage/coursesDetails/coursesDetails'
import C2wLayout from '../components/C2wHome/Layout/C2wLayout'
import C2wEventsDetails from './c2wHomePage/events/eventDetails/EventsDetails'
import C2wAboutUs from './aboutus/AboutUs'

function RouterComponent() {
  const location = useLocation()
  const settingFlag = useSelector((state) => state.data.settingFlag)
  const match = matchPath(`${COURSEDETAILS}/:id`, location.pathname);
  const hideNavbar = Boolean(match);
  return (
    <div>
      {hideNavbar === false ? <C2wNavbar /> : null}
      {settingFlag && <SettingsSheet />}
      <Routes>
        <Route element={<C2wLayout />}>
          <Route path={HOME} element={<></>} />
          <Route path={SUPERX} element={<C2wSuperxHome />} />
          <Route path={LOGIN_PERMISSION} element={<C2wLoginPermission />} />
          <Route path={ABOUTUS} element={<C2wAboutUs />} />
          <Route path={TANDC} element={<C2wTermsAndConditions />} />
          <Route path={REFUND_POLICY} element={<C2wRefundPolicy />} />
          <Route path={CONTACT} element={<C2wEnquiry />} />
          <Route path={COURSES} element={<C2wCourses />} />
          <Route path={`${COURSEDETAILS}/:slug`} element={<C2wCoursesDetails />} />
          <Route path={PLACEMENTS} element={<C2wPlacemets />} />
          <Route path={COMPANIES} element={<C2wCompanies />} />
           <Route path={`${EVENTSDETAILS}/:slug`} element={<C2wEventsDetails/>} />
        </Route>
      </Routes>
    </div>
  )
}

export default RouterComponent
